import React from 'react';

import { Button } from '@mui';
import Tooltip from '@material-ui/core/Tooltip';

import PropTypes from 'prop-types';

// Standard (default) dialog action buttons.
const DialogActions = ({
  backLabel = 'BACK',
  cancelLabel = 'CANCEL',
  disabledBack = false,
  disabledCancel = false,
  disabledSubmit = false,
  onBack,
  onCancel,
  onSubmit,
  submitColor = 'primary',
  submitLabel,
  backProps = {},
  submitProps = {},
  submitTooltip = null
}) => {
  const hasBack = !!onBack;
  const containerStyle = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: hasBack ? 'space-between' : 'flex-end',
    width: '100%'
  };

  return (
    <div style={containerStyle}>
      {hasBack && (
        <Button
          plain
          disabled={disabledBack}
          onClick={onBack}
          {...backProps}
        >
          {backLabel}
        </Button>
      )}
      <div>
        <Button
          plain
          disabled={disabledCancel}
          onClick={onCancel}
          style={{ marginRight: '1rem' }}
        >
          {cancelLabel}
        </Button>
        {submitTooltip ? (
          <Tooltip title={submitTooltip}>
            {/* The wrapping <span> is required, else the disabled
                button won't trigger the tooltip. */}
            <span>
              <Button
                plain
                color={submitColor}
                disabled={disabledSubmit}
                variant="contained"
                {...submitProps}
              >
                {submitLabel}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            plain
            color={submitColor}
            disabled={disabledSubmit}
            onClick={onSubmit}
            variant="contained"
            {...submitProps}
          >
            {submitLabel}
          </Button>
        )
        }
      </div>
    </div>
  );
};

DialogActions.propTypes = {
  backLabel: PropTypes.string,
  backProps: PropTypes.object,
  cancelLabel: PropTypes.string,
  disabledBack: PropTypes.bool,
  disabledCancel: PropTypes.bool,
  disabledSubmit: PropTypes.bool,
  onBack: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  submitColor: PropTypes.string,
  submitLabel: PropTypes.string,
  submitProps: PropTypes.object,
  submitTooltip: PropTypes.string
};

export default DialogActions;
